import React from 'react'

interface YesNoBadgeProps {
  value: boolean
  yesText?: string
  noText?: string
}

export const YesNoBadge: React.FC<YesNoBadgeProps> = ({
  value,
  yesText = 'Si',
  noText = 'No'
}) => {
  const backgroundColor = value ? '#1976d2' : '#e0e0e0'
  const colorText = value ? 'white' : '#616161'
  const text = value ? yesText : noText

  return (
    <div
      style={{
        display: 'inline-block',
        minWidth: 50,
        textAlign: 'center',
        borderRadius: '12px',
        padding: '2px 8px',
        fontSize: '11px',
        backgroundColor,
        color: colorText,
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 2px rgba(0,0,0,0.15)'
      }}
    >
      {text}
    </div>
  )
}
